import { queryOptions } from '@tanstack/react-query';
import { client } from '#queries/utils';

// ? this endpoint is going to be deprecated during April 2026 and will not have proto types for now.
// ? Moving it inside api-kit enable us to create abstractions inside @repo/due-diligence-kit to migrate to the new api

export const KYC_STATUS = {
  PENDING: 'pending',
  REVIEWABLE: 'reviewable',
  SUBMITTED: 'submitted',
  ACCEPTED: 'accepted',
  REFUSED: 'refused',
  WAITING_DOCUMENT: 'waiting_document',
  SUBMISSION_ERROR: 'submission_error',
  KYC_NOT_APPLICABLE: 'kyc_not_applicable',
  PROCESSING: 'processing',
} as const;

interface KycAttributes {
  kyc_status: string;
  provider_name: string;
  is_renewal_poi_required: boolean;
  is_re_kyc_required: boolean;
  re_kyc_due_date?: string;
}

interface KycResponse {
  data: {
    type: string;
    id: string;
    attributes: KycAttributes;
  };
}

export type IdentitiesKycStatus = (typeof KYC_STATUS)[keyof typeof KYC_STATUS];

export interface IdentitiesKyc {
  isReKycRequired: KycAttributes['is_re_kyc_required'];
  isRenewalPoiRequired: KycAttributes['is_renewal_poi_required'];
  reKycDueDate: KycAttributes['re_kyc_due_date'];
  kycStatus: IdentitiesKycStatus;
}

/**
 * @deprecated Use {@link fetchKycAcceptance} from `@repo/api-kit/queries/due-diligence/kyc` instead.
 * This endpoint (`/v1/identities/:id/kyc`) will be removed in April 2026.
 */
export async function fetchIdentitiesKyc(identityId: string): Promise<IdentitiesKyc> {
  const res = await client<KycResponse>(`/v1/identities/${identityId}/kyc`);

  const attributes = res.data.attributes;

  return {
    isReKycRequired: Boolean(attributes.is_re_kyc_required),
    isRenewalPoiRequired: Boolean(attributes.is_renewal_poi_required),
    reKycDueDate: attributes.re_kyc_due_date,
    kycStatus: attributes.kyc_status as IdentitiesKycStatus,
  };
}

/**
 * @deprecated Use {@link kycQueries} from `@repo/api-kit/queries/due-diligence/kyc` instead.
 * This endpoint (`/v1/identities/:id/kyc`) will be removed in April 2026.
 */
export const identitiesKycQueries = {
  all: ['identitiesKyc'] as const,
  item: (identityId: string) =>
    queryOptions({
      queryKey: [...identitiesKycQueries.all, identityId],
      queryFn: async () => fetchIdentitiesKyc(identityId),
    }),
};
